module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('em', [_vm._v("Change the title of your shopping list here")]), _vm._v(" "), _c('input', {
    domProps: {
      "value": _vm.title
    },
    on: {
      "input": function($event) {
        return _vm.onInput({
          title: $event.target.value,
          id: _vm.id
        })
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73d0c334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangeTitleComponent.vue
// module id = 58
// module chunks = 1